<div class="layout">
  <app-dn-logo />

  <div class="container">

    <dn-forgot-password
    [skipCaptcha]="skipCaptcha"
    [forgotPasswordType]="forgotPasswordMode"
    [token]="token"
    [email]="email"
    (goToLogin)="goToLogin()"
    (resendLinkResponse)="resendLinkResponse($event)"
    (resetPasswordResponse)="resetPasswordResponse($event)" />
  </div>

</div>
